import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'locale.modal.title',
        defaultMessage: 'Choose language',
    },
    error: {
        id: 'locale.modal.action.change.error',
        defaultMessage: 'Something went wrong',
    },
    content: {
        id: 'locale.modal.action.change.error_content',
        defaultMessage: "Can't change locale",
    },
    notFound: {
        id: 'locale.modal.select.not_found',
        defaultMessage: 'No locale found',
    },
    success: {
        id: 'locale.modal.select.success',
        defaultMessage: 'Language has changed',
    },
})
